import { orderBy } from "lodash";

const getServiceOptions = ({
  project,
  customer,
  users,
  user,
  customers,
  projects,
  services
}) => {
  const assignedTo = users.find((u) => u._id === user);

  const GraVoc = customers.find((c) => c.number === "GRAVOCAS01");
  const personalProject = projects.find(
    (p) => p.project_number === "GRAVOCASSO-0076"
  );
  const personalServices = new Set([961, 985, 991, 992, 993, 994]);

  const serviceOptions = services
    .filter((service) => {
      if (service.status) {
        // if personal time, return only personal services
        if (personalProject && project && project._id === personalProject._id) {
          if (personalServices.has(service.code)) {
            return service;
          }
        }
        // if customer is GraVoc and project is not personal, return all services except perosnal ones
        else if (GraVoc && customer === GraVoc._id) {
          if (!personalServices.has(service.code)) {
            return service;
          }
        }
        // otherwise match assignedTo department with service department
        // OR service with all department === true
        else if (
          assignedTo?.department?._id === service?.department?._id ||
          service?.all_departments
        ) {
          return service;
        }
        return false;
      }
      return false;
    })
    .map((service) => ({ value: service._id, label: service.description }));

  return orderBy(serviceOptions, "label");
};

export default getServiceOptions;
